import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import { z } from 'zod';

import { publicHttpClient } from '../httpClient';
import { joinApiPath } from './apiPath';

export const CheckJoinEligibilityRequestParamsSchema = z.object({});

export type CheckJoinEligibilityRequestParams = z.infer<
  typeof CheckJoinEligibilityRequestParamsSchema
>;

export const CheckJoinEligibilityResponseSchema = z.object({
  eligible: z.boolean(),
  restrictionType: z.string().nullable(),
});

export type CheckJoinEligibilityResponse = MusinsaStandardResponse<
  z.infer<typeof CheckJoinEligibilityResponseSchema>
>;

export const checkJoinEligibility = (params: CheckJoinEligibilityRequestParams) =>
  executeStandardRequest(() =>
    publicHttpClient.get<CheckJoinEligibilityResponse>(
      urlJoin(joinApiPath.checkEligibility),
      params,
    ),
  );
